import Container from 'react-bootstrap/Container';
import { CabecalhoInstitucional } from '../../components/CabecalhoInstitucional';
import { RodapeInstitucional } from '../../components/RodapeInstitucional';

export function TermosDeUso() {
  return (
    <div>
      <CabecalhoInstitucional />

      <Container as="main" style={{ maxWidth: '760px' }} className="py-4 pb-5">
        <div style={{ lineHeight: 1.7 }}>
          <h1 style={{ fontSize: '28px' }}>Termos e Condições de Contrato</h1>
          <p style={{ fontSize: '13px', color: 'var(--cor-texto)' }}>Última atualização: julho de 2026</p>

          <p>
            Estes Termos regulam o uso do sistema <strong>Lizzi Food</strong>, oferecido por Lizzi Food (CNPJ
            58.030.824/0001-94). Ao criar uma conta, você declara que leu e concorda com estas condições.
          </p>

          <h2 style={{ fontSize: '19px' }}>1. Objeto</h2>
          <p>
            O Lizzi Food é um sistema de gestão para restaurantes que oferece cardápio digital com QR Code, pedidos,
            tela de cozinha (KDS), controle de matéria-prima e produtos, equipe, financeiro e relatórios.
          </p>

          <h2 style={{ fontSize: '19px' }}>2. Plano e pagamento</h2>
          <p>
            O Lizzi Food é oferecido em plano único de R$ 70,00 por mês, cobrado mensalmente, ou no ciclo anual (12
            meses) com 10% de desconto sobre o valor mensal. Não há taxa de adesão nem fidelidade — o cancelamento
            pode ser feito a qualquer momento, encerrando a cobrança a partir do próximo ciclo.
          </p>

          <h2 style={{ fontSize: '19px' }}>3. Cadastro e responsabilidades do usuário</h2>
          <ul>
            <li>Você é responsável por manter sua senha em sigilo e por todas as atividades realizadas na sua conta;</li>
            <li>Os dados cadastrados (cardápio, preços, estoque, financeiro) são de responsabilidade do estabelecimento que os insere;</li>
            <li>É proibido usar a plataforma para fins ilícitos ou que violem direitos de terceiros.</li>
          </ul>

          <h2 style={{ fontSize: '19px' }}>4. Disponibilidade do serviço</h2>
          <p>
            Buscamos manter o sistema disponível de forma contínua, mas não garantimos operação ininterrupta e livre de
            falhas. Manutenções podem ser realizadas com ou sem aviso prévio quando necessário.
          </p>

          <h2 style={{ fontSize: '19px' }}>5. Propriedade intelectual</h2>
          <p>
            O software, a marca Lizzi Food e seus elementos visuais são de propriedade da empresa. O uso da plataforma
            não transfere ao usuário nenhum direito sobre o software além do necessário para utilizá-lo conforme estes
            Termos.
          </p>

          <h2 style={{ fontSize: '19px' }}>6. Cancelamento</h2>
          <p>
            Você pode encerrar o uso da plataforma a qualquer momento. Reservamo-nos o direito de suspender ou encerrar
            contas que violem estes Termos ou a legislação aplicável.
          </p>

          <h2 style={{ fontSize: '19px' }}>7. Foro</h2>
          <p>Fica eleito o foro do domicílio da empresa para dirimir eventuais controvérsias decorrentes destes Termos.</p>

          <h2 style={{ fontSize: '19px' }}>8. Contato</h2>
          <p>
            Dúvidas sobre estes Termos podem ser enviadas pelo WhatsApp{' '}
            <a href="https://wa.me/5519998028779" target="_blank" rel="noreferrer" style={{ color: 'var(--cor-primaria)' }}>
              (19) 99802-8779
            </a>
            .
          </p>
        </div>
      </Container>

      <RodapeInstitucional />
    </div>
  );
}
